var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"about"},[_c('geo-map',{ref:"basicMap",staticStyle:{"background":"#002556"},attrs:{"height":'800'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }